import * as Yup from 'yup'

import { EMPTY_LIST, NOTIFICATION_TYPE } from '../../../../constants/common'
import { NOTIFICATION_FILE_UPLOAD_LIMIT } from '../../../../constants/notification'
import i18n from '../../../../i18n'
import {
  EMAIL_CREATION_FORM_FIELD_NAME_BCC,
  EMAIL_CREATION_FORM_FIELD_NAME_CC,
  EMAIL_CREATION_FORM_FIELD_NAME_DOCUMENTS_TEMPLATES,
  EMAIL_CREATION_FORM_FIELD_NAME_FILES,
  EMAIL_CREATION_FORM_FIELD_NAME_FROM,
  EMAIL_CREATION_FORM_FIELD_NAME_MASS_MAILING,
  EMAIL_CREATION_FORM_FIELD_NAME_MESSAGE,
  EMAIL_CREATION_FORM_FIELD_NAME_PRINTER,
  EMAIL_CREATION_FORM_FIELD_NAME_REPLY_TO,
  EMAIL_CREATION_FORM_FIELD_NAME_SELECTED_TEMPLATE,
  EMAIL_CREATION_FORM_FIELD_NAME_SUBJECT,
  EMAIL_CREATION_FORM_FIELD_NAME_TO,
  EMAIL_CREATION_FORM_INITIAL_VALUES,
  EMAIL_CREATION_FORM_NOTIFICATION_SEPARATE_EMAILS,
  getEmailFormValidationSchema,
  toEmailRecipientSelectItems,
} from '../../../Email'
import { toUserSelectItems } from '../../../User'
import { DocFlowSendingWidgetProcessFieldName } from '../../DocFlowSending'

function toEmailFormDocTemplate(documentTemplate) {
  return {
    ...documentTemplate,
    id: documentTemplate.template,
  }
}

function toEmailFormDocTemplates(documentTemplates) {
  return documentTemplates.map(toEmailFormDocTemplate)
}

export function getDocFlowSendingEmailContentFieldsProps(phaseDisabled) {
  return {
    // temporarily removing the info account
    [EMAIL_CREATION_FORM_FIELD_NAME_FROM]: {
      blocked: phaseDisabled,
      mass: false,
    },
    [EMAIL_CREATION_FORM_FIELD_NAME_TO]: {
      FilterButton: null,
      blocked: true,
      isDragDisabled: true,
      isDropDisabled: true,
    },
    ...(phaseDisabled
      ? {
          [EMAIL_CREATION_FORM_FIELD_NAME_BCC]: {
            FilterButton: null,
            blocked: true,
            isDragDisabled: true,
            isDropDisabled: true,
          },
          [EMAIL_CREATION_FORM_FIELD_NAME_CC]: {
            FilterButton: null,
            blocked: true,
            isDragDisabled: true,
            isDropDisabled: true,
          },
        }
      : null),
  }
}

export function getDocFlowSendingEmailContentValidationSchema() {
  return getEmailFormValidationSchema().shape({
    [EMAIL_CREATION_FORM_FIELD_NAME_REPLY_TO]: Yup.array()
      .nullable()
      .notRequired(),
  })
}

export function isDocFlowSendingEmailContentAvailablePreview() {
  return true
}

export function isDocFlowSendingEmailContentAvailableTestVariables({
  emptyMessage,
  emptyRecipients,
  hasDocTemplates,
  values,
}) {
  return (
    !emptyRecipients &&
    !emptyMessage &&
    (hasDocTemplates ||
      values[EMAIL_CREATION_FORM_FIELD_NAME_SELECTED_TEMPLATE]?.id)
  )
}

export function isDocFlowSendingEmailContentFileLimit({ filesSize, maxSize }) {
  return filesSize > maxSize
}

export function getDocFlowSendingEmilContentNotificationFileLimit() {
  return {
    id: NOTIFICATION_FILE_UPLOAD_LIMIT,
    text: i18n.t('DocumentStapling.UploadFilesLimitErrorKey'),
    type: NOTIFICATION_TYPE.warning,
  }
}

export function getDocFlowSendingEmilContentNotificationMassMailing() {
  return {
    id: EMAIL_CREATION_FORM_NOTIFICATION_SEPARATE_EMAILS,
    text: i18n.t('DocumentStapling.SeparateEmailsNotificationTextKey'),
    type: NOTIFICATION_TYPE.info,
  }
}

export function getDocFlowSendingEmailContentInitialValues(processData) {
  const {
    [DocFlowSendingWidgetProcessFieldName.EmailDocumentTemplates]:
      templates = EMPTY_LIST,
    [DocFlowSendingWidgetProcessFieldName.EmailFiles]: files,
    [DocFlowSendingWidgetProcessFieldName.EmailText]: message,
    [DocFlowSendingWidgetProcessFieldName.EmailTitle]: subject,
    email_participants: {
      [EMAIL_CREATION_FORM_FIELD_NAME_BCC]: bccItems,
      [EMAIL_CREATION_FORM_FIELD_NAME_CC]: ccItems,
      [EMAIL_CREATION_FORM_FIELD_NAME_TO]: toItems,
    },
  } = processData

  return {
    ...EMAIL_CREATION_FORM_INITIAL_VALUES,
    [EMAIL_CREATION_FORM_FIELD_NAME_BCC]: toUserSelectItems(bccItems),
    [EMAIL_CREATION_FORM_FIELD_NAME_CC]: toUserSelectItems(ccItems),
    [EMAIL_CREATION_FORM_FIELD_NAME_DOCUMENTS_TEMPLATES]:
      toEmailFormDocTemplates(templates),
    [EMAIL_CREATION_FORM_FIELD_NAME_FILES]: files,
    [EMAIL_CREATION_FORM_FIELD_NAME_MASS_MAILING]: true,
    [EMAIL_CREATION_FORM_FIELD_NAME_MESSAGE]: message,
    [EMAIL_CREATION_FORM_FIELD_NAME_PRINTER]: processData[
      DocFlowSendingWidgetProcessFieldName.EmailPrinterId
    ]
      ? {
          email: processData[DocFlowSendingWidgetProcessFieldName.EmailPrinter],
          id: processData[DocFlowSendingWidgetProcessFieldName.EmailPrinterId],
        }
      : null,
    [EMAIL_CREATION_FORM_FIELD_NAME_SELECTED_TEMPLATE]: processData[
      DocFlowSendingWidgetProcessFieldName.EmailSnippet
    ]
      ? {
          dependencies:
            processData[
              DocFlowSendingWidgetProcessFieldName.EmailSettingsPhase
            ],
          id: processData[DocFlowSendingWidgetProcessFieldName.EmailSnippet],
        }
      : null,
    [EMAIL_CREATION_FORM_FIELD_NAME_SUBJECT]: subject,
    [EMAIL_CREATION_FORM_FIELD_NAME_TO]: toEmailRecipientSelectItems(toItems),
  }
}
